module.exports = __webpack_public_path__ + "img/size_2_3.145b00b7.png";